import { render, staticRenderFns } from "./TxForensicsPanel.vue?vue&type=template&id=c06406d0&scoped=true"
import script from "./TxForensicsPanel.vue?vue&type=script&lang=ts"
export * from "./TxForensicsPanel.vue?vue&type=script&lang=ts"
import style0 from "./TxForensicsPanel.vue?vue&type=style&index=0&id=c06406d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06406d0",
  null
  
)

export default component.exports